import { PaymentSumByMonth } from 'src/modules/dashboard/models/paymentSumByMonth';
import { PaymentGroupedByDate } from 'src/modules/invoice/models/paymentGroupedByDate';
import AxiosInstance from 'src/shared/services/axios/interceptor';
import { AccountingRecord } from 'src/modules/invoice/models/accountingRecord';
import { PaymentTransactionPost } from 'src/modules/invoice/models/createTransaction';
import { InvoicePayment } from 'src/modules/invoice/models/invoicePayment';
import { PaymentsSearchFilter } from 'src/modules/invoice/models/paymentsSearchFilter';
import { PagedResult } from '../models/pagedResult';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'Payment';

export const getPaymentSumByMonth = (startDate: string, endDate: string) => {
  let extraQuery = '';
  extraQuery += startDate ? `&startDate=${startDate}` : '';
  extraQuery += endDate ? `&endDate=${endDate}` : '';
  const endpoint = `${controller}/SumByMonth?${extraQuery}`;
  return AxiosInstance.get<PaymentSumByMonth[]>(endpoint);
};

export const getAllPayments = (searchFilter: PaymentsSearchFilter) => {
  const { filter, pageIndex, pageSize, sortCol, sortDir, ownerId } = searchFilter;
  let endpoint = `${controller}?${setPagingParams({ pageIndex, pageSize, sortCol: sortCol ?? 'date', sortDir: sortDir ?? 'desc' })}`;

  if (ownerId) {
    endpoint += `&ownerId=${ownerId}`;
  }
  if (filter) {
    endpoint += `&filter=${filter}`;
  }
  return AxiosInstance.get<PagedResult<InvoicePayment>>(endpoint);
};

export const getPayments = (pageIndex, pageSize, sortCol, sortDir, searchString: string, ownerId?: number) => {
  const endpoint = `${controller}/GroupedByDate?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}&ownerId=${ownerId || ''}&filter=${
    searchString || ''
  }`;
  return AxiosInstance.get<PagedResult<PaymentGroupedByDate>>(endpoint);
};

export const getAccountingRecords = (pageIndex, pageSize, sortCol, sortDir, searchString: string, ownerId?: number) => {
  const endpoint = `${controller}/AccountingRecord?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}&ownerId=${ownerId || ''}&filter=${
    searchString || ''
  }`;
  return AxiosInstance.get<PagedResult<AccountingRecord>>(endpoint);
};

export const createAccountingRecords = (data: string[], ownerId: number) => {
  const endpoint = `${controller}/AccountingRecord?ownerId=${ownerId}`;
  return AxiosInstance.post(endpoint, data);
};

export const exportAccountingRecords = (format: string, verificationNumbers: number[], ownerId: number) => {
  let result = '';
  verificationNumbers.forEach((x) => {
    result += x && `&verificationNumbers=${x}`;
  });
  const endpoint = `${controller}/AccountingRecord/Export?format=${format}${result}&ownerId=${ownerId}`;
  return AxiosInstance.get(endpoint);
};

export const createPaymentTransaction = (data: PaymentTransactionPost) => {
  return AxiosInstance.post(controller, data);
};

export const createMultiplePaymentsTransactions = (data: PaymentTransactionPost) => {
  return AxiosInstance.post(`${controller}/CreatePayments`, data);
};
